import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, "ОБЕДОМАТ", -1)

import { usePermissions } from "@/use/usePermissions";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";

import AppTabbar from "@/components/AppTabbar.vue";
import AppSidebar from "@/components/AppSidebar.vue";

import RequestsList from "../components/RequestsList.vue";
import UiAppbarButton from "@/plugins/ui/components/appbar/UiAppbarButton.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestsPage',
  setup(__props) {

const { isAllow, getDenyType } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "ОБЕДОМАТ"
      }, {
        right: _withCtx(() => [
          _createVNode(UiAppbarButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings')))
          }, {
            default: _withCtx(() => [
              _createVNode(UiIcon, { icon: "Cog" })
            ]),
            _: 1
          }),
          _createVNode(UiAppbarButton, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/requests/create')))
          }, {
            default: _withCtx(() => [
              _createVNode(UiIcon, { icon: "Plus" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (_unref(isAllow)('request'))
        ? (_openBlock(), _createBlock(RequestsList, { key: 0 }))
        : (_unref(getDenyType)('request') === 'unsupported')
          ? (_openBlock(), _createBlock(UiPlaceholder, {
              key: 1,
              icon: "ShoppingBag",
              title: "Модуль «ОБЕДОМАТ» недоступен",
              description: "К сожалению, модуль «ОБЕДОМАТ» не подключен к вашей школе."
            }))
          : (_unref(getDenyType)('request') === 'subscription')
            ? (_openBlock(), _createBlock(UiPlaceholder, {
                key: 2,
                icon: "ShoppingBag",
                title: "Модуль «ОБЕДОМАТ» доступен по подписке",
                description: "Модуль «ОБЕДОМАТ» будет доступен после оформления расширенной подписки."
              }))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})